import {Item} from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import type {DropdownMenuItemProps} from '@radix-ui/react-dropdown-menu';

export function DropdownItem({
  ref: forwardedRef,
  children,
  className,
  danger,
  ...props
}: DropdownMenuItemProps &
  React.RefAttributes<HTMLDivElement> & {danger?: boolean}): React.JSX.Element {
  const styles = clsx(
    className,
    'cursor-pointer px-2 py-1 text-sm radix-disabled:cursor-default radix-disabled:text-slate10 radix-highlighted:font-semibold radix-highlighted:text-white radix-highlighted:outline-hidden',
    danger ? 'radix-highlighted:bg-tomato10' : 'radix-highlighted:bg-blue10'
  );

  return (
    <Item {...props} ref={forwardedRef} className={styles}>
      {children}
    </Item>
  );
}

DropdownItem.displayName = 'DropdownItem';
